import { makeAutoObservable } from 'mobx'
import type { IResponseHubspotWorkflow } from 'entities/HubspotWorkflows/api/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { HubspotWorkflowStatistics } from './HubspotWorkflowStatistics'

export type IHubspotWorkflow = HubspotWorkflow

export class HubspotWorkflow {
  id: number
  name: string
  organizationId: number
  workflowId: string
  isDeleted: boolean
  firstMessageDate: string | null
  total: number
  statistics: HubspotWorkflowStatistics | null

  constructor(item: IResponseHubspotWorkflow, private _entities: IEntitiesStore) {
    this.id = item.id
    this.name = item.name || ''
    this.workflowId = item.workflow_id
    this.isDeleted = item.is_deleted
    this.firstMessageDate = item.first_message_date || null
    this.total = item.total
    this.organizationId = item.organization_id
    this.statistics = item.statistics
      ? new HubspotWorkflowStatistics(item.statistics, this._entities)
      : null

    makeAutoObservable(this)
  }
}
